export default __webpack_public_path__ + "static/thumbnail_trash-0f00e51ec576f37481f09c578defc8c6.png";